import React from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Skeleton from "@material-ui/lab/Skeleton";

export type FieldType = "text" | "select" | "switch";

interface FormSkeletonProps {
  fields: FieldType[];
}

const FormSkeleton: React.FC<FormSkeletonProps> = ({ fields }) => {
  return (
    <Grid container spacing={2}>
      {fields.map((type: FieldType, index: number) => {
        const isSmall = type === "switch";
        const height = isSmall ? 36 : 56;

        return (
          <Grid item xs={12} sm={6} key={index}>
            <Skeleton variant="text" width="40%" height={100} />
            <Box style={{ borderRadius: 4, marginTop: 16 }}>
              <Skeleton variant="rect" height={height} />
            </Box>
            {isSmall && (
              <Box mt={1}>
                <Skeleton variant="text" width="30%" height={14} />
              </Box>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default FormSkeleton;
